import Handsontable from 'handsontable';
import { CellSelections } from '../../../../../../common/table/TableTypes';
import { getAllSelectedCols, isColInSelections, isRowInSelection } from '../tableCellSelectionUtils';

/**
 * Returns the current rendered width of every visual column in pixels.
 */
export const getHotTableColumnWidthsPx = (hotInstance: Handsontable): number[] => {
    const colWidthsPx: number[] = [];

    for (let col = 0; col < hotInstance.countCols(); col++) {
        colWidthsPx.push(hotInstance.getColWidth(col));
    }

    return colWidthsPx;
};

/**
 * Resolves which columns should participate in a column-resize gesture for the given resized column.
 */
export const getResizeTargetColumns = (
    selections: CellSelections | null | undefined,
    resizeColumn: number,
): number[] => {
    if (!selections) return [resizeColumn];

    const headerSelections = selections.reduce<CellSelections>(
        (acc, selection) => (isRowInSelection(-1, selection) ? [...acc, selection] : acc),
        [],
    );

    if (headerSelections.length && isColInSelections(resizeColumn, headerSelections)) {
        return getAllSelectedCols(headerSelections);
    }

    return [resizeColumn];
};
